/** @jsxRuntime classic */
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import {
  BlockGrid as ZinniaBlockGrid,
  BlockGridProps as ZinniaBlockGridProps,
  Button,
} from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import {
  BackgroundColorKey,
  HeadingSize,
  SemanticColor,
  SEMANTIC_COLORS,
} from '../../../constants';
import { Section } from '../../Section/Section';
import { SectionName } from '../../../observability/tracking/events';
import { Background } from '../../Section/background';
import { CTAType, useAvroTracking } from '../../../observability';
import { BuilderComponentProps } from '../../../builder';

export interface BlockGridProps
  extends ZinniaBlockGridProps,
    BuilderComponentProps {
  sectionHeadingSize?: HeadingSize;
  ctaColor?: SemanticColor;
  ctaHref?: string;
  ctaText?: string;
  sectionHeading?: string;
  sectionSubheading?: string;
  backgroundColor?: BackgroundColorKey;
}

const Styles = labelStyles('BlockGrid', {
  footer: css({
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '90px',
  }),
});

export function BlockGrid({
  children,
  ctaColor = SEMANTIC_COLORS.primaryAlt,
  ctaText,
  ctaHref,
  maxColumns,
  sectionHeading,
  sectionSubheading,
  backgroundColor,
  sectionHeadingSize,
  builderBlock,
}: BlockGridProps) {
  const { emitCTAClickEvent } = useAvroTracking();
  const shouldDisplayFooter = !!ctaHref && !!ctaText;

  return (
    <Section
      background={backgroundColor as Background}
      contentWidth="fullWidth"
      heading={sectionHeading}
      headingSize={sectionHeadingSize}
      layerName={builderBlock?.layerName}
      sectionToTrack={SectionName.BlockGrid}
      subheading={sectionSubheading}
    >
      <ZinniaBlockGrid maxColumns={maxColumns}>{children}</ZinniaBlockGrid>
      {shouldDisplayFooter && (
        <div css={Styles.footer}>
          <Button
            color={ctaColor}
            href={ctaHref}
            onClick={() => {
              emitCTAClickEvent({
                text: ctaText,
                href: ctaHref,
                section: 'BlockGrid',
                type: CTAType.cta_link,
              });
            }}
          >
            {ctaText}
          </Button>
        </div>
      )}
    </Section>
  );
}
